import React from 'react';
import FlatList from '../../../Base/Components/FlatList';
import EArchiveListItem from '../EArchiveListItem/EArchiveListItem';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import { View } from '../../../../Enums/View.enum';
import styles from './EArchivePatientList.module.scss';
import { WorkplaceMember } from '../../../../graphql/graphql';
import useScrollGuard from '../../../Base/Hooks/useScrollGuard';

interface Props {
	loadData: () => void;
	getNextPage: () => void;
	data: WorkplaceMember[];
	isLoading: boolean;
	hasMoreData: boolean;
	view: View;
	groupType?: string;
}

const WRAPPER_ID = 'eArchivePatientList';

const EArchivePatientList = ({
	loadData,
	getNextPage,
	data,
	isLoading,
	hasMoreData,
	view,
	groupType,
}: Props) => {
	const { scrollContainerRef } = useScrollGuard<WorkplaceMember>({
		data,
		isLoading,
		onLoadMore: getNextPage,
		hasMoreData,
	});

	return (
		<ScrollContainer
			wrapperId={WRAPPER_ID}
			ref={scrollContainerRef}
			className={styles.background}>
			<FlatList
				onRefresh={loadData}
				onLoadMore={getNextPage}
				data={data}
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				scrollableTargetId={WRAPPER_ID}
				itemKey='id'
				className={styles[view]}
				renderItem={item => (
					<EArchiveListItem
						item={item}
						onRefresh={loadData}
						view={view}
						groupType={groupType}
					/>
				)}
			/>
		</ScrollContainer>
	);
};

export default EArchivePatientList;
